// We're using direct HTTP calls here, skipping Proxy
import axios from "axios";

export default function(schoolId, file, onUploadProgress) {
  let API_URL
  if (process.env.APP_ENV == 'development') {
    API_URL = 'https://saas.classtop.com:3001/sapi';
  } else {
    API_URL = 'https://school.classtop.com:3001/sapi';
  }

  if(!schoolId){
    throw 'Missing school ID'
  }

  if(!file){
    throw 'Missing blob'
  }

	return new Promise((resolve, reject) => {
    let data = new FormData();
    data.append('pic', file);

    axios.post(API_URL + '/media_library/' + schoolId + '/', data, {
      'onUploadProgress': (progress)=>{
        if (typeof onUploadProgress == 'function') {
          progress.ratio = progress.loaded / progress.total;
          onUploadProgress(progress);
        }
      },
      headers: {
        'Authorization': 'JWT ' + localStorage.getItem('token'),
        'Content-Type': 'multipart/form-data',
      }
    })
    .then((res) => {
      resolve(res.data);
    })
    .catch((err) => {
      console.log(err)
    });

  });
}



// WEBPACK FOOTER //
// ./src/controllers/controllers/mediaCenter/imageUploader.js